if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();

      this.resultsContainer = document.getElementById('product-grid');
      this.button = this.querySelector('[data-load-more-btn]');
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      this.button.addEventListener('click', (event) => {
        event.preventDefault();

        this.loadResults();
      });
    }

    loadResults() {
      this.button.classList.add('is-loading');

      fetch(this.button.getAttribute('href'))
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;

          this.renderResults(html);
          this.updateButton(html);
        });
    }

    renderResults(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const productsGrid = parsedHTML.getElementById('product-grid');

      if (!productsGrid) return;

      const results = productsGrid.querySelectorAll('.grid__item');

      results.forEach((result) => {
        this.resultsContainer.appendChild(result);
      });
    }

    updateButton(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const loadMoreButton = parsedHTML.querySelector('[data-load-more-btn]');

      if (!loadMoreButton) {
        this.button.remove();

        return;
      }

      this.button.href = loadMoreButton.href;

      this.button.classList.remove('is-loading');
    }
  }

  customElements.define('load-more', LoadMore);
}
